(() => {
  const popup = document.querySelector('[data-guest-signup-popup]');
  if (!popup) return;

  const storageKey = 'wigBangladeshGuestSignupDismissedAt';
  const dismissalPeriod = 14 * 24 * 60 * 60 * 1000;
  const submittedSuccessfully = popup.dataset.submittedSuccessfully === 'true';
  let previouslyFocusedElement = null;

  const hasActiveShopifyFormsPopup = () =>
    Array.from(document.querySelectorAll('shopify-forms-embed, [data-shopify-forms]')).some((element) => {
      const style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });

  const rememberDismissal = () => {
    try {
      localStorage.setItem(storageKey, String(Date.now()));
    } catch (_error) {
      // Storage can be unavailable in privacy modes; closing still works.
    }
  };

  const wasRecentlyDismissed = () => {
    try {
      const dismissedAt = Number(localStorage.getItem(storageKey));
      return dismissedAt > 0 && Date.now() - dismissedAt < dismissalPeriod;
    } catch (_error) {
      return false;
    }
  };

  const closePopup = () => {
    popup.hidden = true;
    rememberDismissal();
    previouslyFocusedElement?.focus();
  };

  const openPopup = () => {
    if (!submittedSuccessfully && (wasRecentlyDismissed() || hasActiveShopifyFormsPopup())) return;

    previouslyFocusedElement = document.activeElement;
    popup.hidden = false;
    popup.querySelector('.guest-signup-popup__dialog')?.focus();
  };

  popup.querySelectorAll('[data-guest-signup-close]').forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) closePopup();
  });

  if (submittedSuccessfully) {
    rememberDismissal();
    openPopup();
  } else {
    window.setTimeout(openPopup, 2500);
  }
})();
